const mistakes = [
  {
    icon: "ri-camera-off-line",
    title: "Incorrect Passport Photo",
    description: "Photos must meet strict U.S. government specifications — size, background, expression, and recency. A rejected photo delays your entire application.",
  },
  {
    icon: "ri-file-damage-line",
    title: "Missing or Incomplete Forms",
    description: "DS-11 (new passports) and DS-82 (renewals) must be filled out completely and correctly. Errors or missing fields cause automatic rejection.",
  },
  {
    icon: "ri-calendar-close-line",
    title: "Expired Supporting Documents",
    description: "Your proof of citizenship (birth certificate, naturalization certificate) and government-issued ID must be current and valid. Expired documents will not be accepted.",
  },
  {
    icon: "ri-pen-nib-line",
    title: "Signing the DS-11 Before the Clerk",
    description: "First-time applicants must NOT sign Form DS-11 before appearing in front of an acceptance clerk. Pre-signing is one of the most common — and costly — mistakes.",
  },
  {
    icon: "ri-time-line",
    title: "Waiting Too Long to Apply",
    description: "Standard government processing can take 1–3 months. Many Wellington travelers wait until the last minute and then face limited options. Start as early as possible.",
  },
  {
    icon: "ri-map-pin-time-line",
    title: "Assuming You Can Walk Into a Passport Agency",
    description: "Regional passport agencies like the Miami office do not allow walk-ins. Appointments are required and availability is limited — especially during peak equestrian season.",
  },
];

export default function WellingtonMistakesSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Avoid Delays</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Application Mistakes
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            These mistakes cause the most delays and rejections for Wellington travelers. Fast Passport Center reviews your documents before submission to catch these issues.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-white rounded-lg p-5 border border-gray-200 hover:border-[#F6C344] transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 flex-shrink-0">
                <i className={`${m.icon} text-red-400 text-lg`}></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-sm mb-1">{m.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-shield-check-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base">We check everything for you.</p>
            <p className="text-white/70 text-sm mt-1">
              Fast Passport Center reviews your documents before submission — so you don&apos;t have to worry about these mistakes causing a delay.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}